import {useRouteError, useNavigate} from "react-router-dom";

export const ErrorPage = () => {
	const error = useRouteError();
	const navigate = useNavigate();
	console.warn(error)

	return(
		<div>
			<h1>And I oop</h1>
			<h4>{error.statusText}</h4>
			<p>{error.message}</p>
			<button onClick={() => navigate('/')}>
				Return to Home
			</button>
		</div>
	);
}